module.exports = __webpack_public_path__ + "img/ic_quote_set.703e1d60.svg";